<template>
    <transition name="modal" v-if="visible">
        <div class="custom-modal-mask">
            <div class="custom-modal-wrapper">
                <div class="custom-modal-container" v-click-outside="hide">
                    <div class="custom-modal-header">
                        <slot name="header">
                            <h5>Thông báo</h5>
                        </slot>
                    </div>

                    <div class="custom-modal-body">
                        <slot name="body">
                            {{content}}
                        </slot>
                    </div>

                    <div class="custom-modal-footer">
                        <slot name="footer">
                            <button class="custom-modal-default-button btn btn-sm btn-primary" @click="hide">
                                OK
                            </button>
                        </slot>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
    import { ModalNotifyPlugin } from '../../../plugins'
    import {MixinHelper} from "../services";
    export default {
        name: "CustomModalNotify",
        mixins: [MixinHelper],
        beforeMount() {
            ModalNotifyPlugin.EventBus.$on('show', (params) => {
                this.show(params);
            });
            ModalNotifyPlugin.EventBus.$on('hide', () => {
                this.hide();
            })
        },
        data() {
            return {
                content: '',
                visible: false
            }
        },
        methods: {
            show(params) {
                this.content = this.getProp(params, 'content', '');
                this.visible = true;
            },
            hide() {
                this.visible = false;
            }
        }
    }
</script>

<style>
    @import "../../../assets/css/custom-modal.css";
</style>
